"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var _1 = require(".");
function IconRenderer(props) {
    var status = props.status, number = props.number;
    if (status === 'finish') {
        return react_1.default.createElement(icons_1.CheckIcon, null);
    }
    if (status === 'error') {
        return react_1.default.createElement(icons_1.CloseIcon, null);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, number);
}
function calcStepStatus(status, current, number) {
    if (number === current) {
        return status;
    }
    if (number < current) {
        return 'finish';
    }
    return 'wait';
}
function Item(props) {
    var className = props.className, style = props.style, title = props.title, description = props.description, icon = props.icon, _a = props.number, number = _a === void 0 ? 0 : _a, rootHtmlProps = props.rootHtmlProps;
    var prefix = ConfigProvider_1.usePrefix('steps-item');
    var _b = react_1.useContext(_1.stepsContext), status = _b.status, current = _b.current, onChange = _b.onChange;
    var stepStatus = calcStepStatus(status, current, number);
    var stepIcon = icon || react_1.default.createElement(IconRenderer, { status: stepStatus, number: number + 1 });
    var handleClick = function (e) {
        var _a;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, e);
        if (e.defaultPrevented)
            return;
        if (onChange)
            onChange(number);
    };
    return (react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: classnames_1.default(prefix, className, utils_1.concat(prefix, stepStatus), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className), style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style), onClick: ((rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) || onChange) && handleClick }),
        react_1.default.createElement("div", { className: utils_1.concat(prefix, 'container') },
            react_1.default.createElement("div", { className: utils_1.concat(prefix, 'tail') }),
            react_1.default.createElement("div", { className: utils_1.concat(prefix, 'icon') },
                react_1.default.createElement("div", { className: utils_1.concat(prefix, 'icon-inner') }, stepIcon)),
            react_1.default.createElement("div", { className: utils_1.concat(prefix, 'content') },
                react_1.default.createElement("div", { className: utils_1.concat(prefix, 'title') }, title),
                react_1.default.createElement("div", { className: utils_1.concat(prefix, 'description') }, description)))));
}
exports.default = Item;
//# sourceMappingURL=Item.js.map